import {
	keepPreviousData,
	type QueryClient,
	queryOptions,
	useQuery,
} from "@tanstack/react-query"
import { GET, type Schema } from "@/api/client"
import { formatDateISO } from "@/lib/format"

export type Ticker = Schema["Ticker"]
export type TickerSeries = Schema["TickerSeries"]
export function priceSeriesOptions(tickers: Ticker[], days: number) {
	const today = new Date()
	const startDate = new Date(today)
	startDate.setDate(startDate.getDate() - days)

	return queryOptions({
		queryKey: ["market-data", "prices", "series", tickers, days],
		queryFn: () =>
			GET("/api/v1/market-data/series", {
				params: {
					query: {
						tickers,
						start_date: formatDateISO(startDate),
						end_date: formatDateISO(today),
					},
				},
			}),
		placeholderData: keepPreviousData,
	})
}

export function usePriceSeries(tickers: Ticker[], days: number = 30) {
	return useQuery(priceSeriesOptions(tickers, days))
}

export function prefetchPriceSeries(
	queryClient: QueryClient,
	tickers: Ticker[],
	days: number,
) {
	queryClient.prefetchQuery(priceSeriesOptions(tickers, days))
}
